module.exports = "pegasus/assets/themelp1/small/29.png";